export const discoverUs = [
    {
        title: 'About Us',
        URL: '/about',
        isExternal: false
    },
    {
        title: "FAQs",
        URL: '#',
        isExternal: false
    },
    {
        title: 'Case Studies',
        URL: '#',
        isExternal: false
    },
    {
        title: 'Blog',
        URL: 'https://blog.dev-hire.com/',
        isExternal: true
    },
    {
        title: 'Events',
        URL: '#',
        isExternal: false
    }
]